import { render, staticRenderFns } from "./FormularioContactoZonaFranca.vue?vue&type=template&id=97439990&"
import script from "./FormularioContactoZonaFranca.vue?vue&type=script&lang=js&"
export * from "./FormularioContactoZonaFranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports